import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax
} from 'styles/media-queries'

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--light);
  position: relative;
  padding: ${calculateResponsiveSize(120)} ${calculateResponsiveSize(350)};
  gap: ${calculateResponsiveSize(24)};
  &.black {
    background: var(--black);
  }
  &.no-footer-nav {
    display: none;
  }
  ${mediaMax('mobile')} {
    padding: ${calculateMobileResponsiveSize(60)}
      ${calculateMobileResponsiveSize(20)};
    gap: ${calculateMobileResponsiveSize(30)};
  }
`
export const Subtitle = styled.div`
  font-family: 'Basis Grotesque';
  font-size: ${calculateResponsiveSize(12)};
  font-weight: 700;
  line-height: ${calculateResponsiveSize(19.2)};
  letter-spacing: 0.1em;
  text-align: center;
  text-transform: uppercase;

  color: var(--black);
  .black & {
    color: var(--light);
  }
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(12)};
    line-height: ${calculateMobileResponsiveSize(19.2)};
  }
`
export const Title = styled.div`
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(42)};
  font-weight: 250;
  line-height: ${calculateResponsiveSize(50.4)};
  text-align: center;
  color: var(--black);

  .black & {
    color: var(--light);
  }
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(30)};
    line-height: ${calculateMobileResponsiveSize(36)};
  }
`

export const Copy = styled.div`
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(18)};
  font-weight: 250;
  line-height: ${calculateResponsiveSize(28.8)};
  text-align: center;
  color: var(--black);

  .black & {
    color: var(--light);
  }
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(16)};
    line-height: ${calculateMobileResponsiveSize(25.6)};
  }
`
